import React from 'react';
import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './toastTransition.css';
var Toast = function () {
    return (React.createElement(ToastContainer, { transition: cssTransition({
            collapse: false,
            enter: 'fade-in-bottom',
            exit: 'fade-out-bottom',
        }), hideProgressBar: true, closeButton: true, position: 'bottom-right' }));
};
// this could actually be removed eventually - pretty much what react-tostify does on its own
var displayToast = function (type, text, autoClose) {
    if (autoClose === void 0) { autoClose = 2000; }
    toast[type](text, {
        autoClose: autoClose,
    });
};
export { Toast as ToastContainer, displayToast };
